mutation CreateContentFromUrl($input: CreateContentFromUrlInput!) {
  createContentFromUrl(input: $input) {
    id
  }
}
